// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

export default {
  TABLE_REPORT: {
    height: 400
  },
  TABLE_REPORT_PART: {
    height: 180
  },
  TABLE_DEF_REPORT: {
    selectedIcon: {
      key: 'selectedIcon',
      labelKey: 'selectedIcon',
      width: 30,
      fixed: true,
      renderMethod: 'renderRadioButton'
    },
    reportName: {
      columnKey: 'reportname',
      key: 'name',
      labelKey: 'name',
      width: 200,
      get title() {
        return localizer.getText('COMMON_LABEL_REPORT_NAME');
      },
      sortable: true,
      renderMethod: 'renderReportData'
    },
    saveInto: {
      columnKey: 'isGlobal',
      key: 'isGlobal',
      labelKey: 'isGlobal',
      width: 120,
      get title() {
        return localizer.getText('COMMON_LABEL_SAVE_INTO');
      },
      sortable: true,
      renderMethod: 'renderSaveInto'
    },
    category: {
      columnKey: 'category',
      key: 'categoryName',
      labelKey: 'categoryName',
      width: 120,
      get title() {
        return localizer.getText('COMMON_LABEL_CATEGORY');
      },
      sortable: true,
      renderMethod: 'renderReportData'
    },
    subCategory: {
      columnKey: 'subCategory',
      key: 'subCategoryName',
      labelKey: 'subCategoryName',
      width: 120,
      get title() {
        return localizer.getText('REPORT_PART_SELECTION_CONSTANTS_SUB_CATEGORY');
      },
      sortable: true,
      renderMethod: 'renderReportData'
    },
    createdBy: {
      columnKey: 'createdBy',
      key: 'createdBy',
      labelKey: 'createdBy',
      width: 105,
      get title() {
        return localizer.getText('COMMON_CRITERIA_CREATED_BY');
      },
      sortable: true,
      renderMethod: 'renderReportData'
    },
    created: {
      columnKey: 'createdDate',
      key: 'created',
      labelKey: 'created',
      width: 120,
      get title() {
        return localizer.getText('COMMON_CRITERIA_CREATED_DATE');
      },
      sortable: true,
      fixed: true,
      renderMethod: 'renderReportData'
    },
    modifiedBy: {
      columnKey: 'lastEditedBy',
      key: 'modifiedBy',
      labelKey: 'modifiedBy',
      width: 125,
      get title() {
        return localizer.getText('COMMON_CRITERIA_EDITED_BY');
      },
      sortable: true,
      renderMethod: 'renderReportData'
    },
    modified: {
      columnKey: 'lastEditedDate',
      key: 'modified',
      labelKey: 'modified',
      width: 135,
      get title() {
        return localizer.getText('COMMON_CRITERIA_EDITED_DATE');
      },
      sortable: true,
      fixed: true,
      renderMethod: 'renderReportData'
    }
  },
  TABLE_DEF_REPORT_PART: {
    selectedIcon: {
      key: 'selectedIcon',
      labelKey: 'selectedIcon',
      width: 30,
      fixed: true
    },
    reportPartTitle: {
      columnKey: 'title',
      key: 'title',
      labelKey: 'title',
      width: 400,
      get title() {
        return localizer.getText('REPORT_PART_SELECTION_CONSTANTS_REPORT_PART_TITLE');
      },
      sortable: true
    },
    reportPartTypeName: {
      columnKey: 'reportPartTypeName',
      key: 'reportPartTypeName',
      labelKey: 'reportPartTypeName',
      width: 400,
      get title() {
        return localizer.getText('REPORT_PART_SELECTION_CONSTANTS_REPORT_PART_TYPE');
      },
      sortable: true
    }
  },
  TYPE: {
    REPORT: 'report',
    REPORT_PART: 'report part'
  }
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.ReportPartSelectionConstants.js